import { boolean, number, string, struct } from 'io-ts/lib/Decoder';

/**
 * BE → UI: one option per discrepant frame length
 */
export const LengthCorrectionOption = struct({
	/** e.g. "15'5\"", "Unsure" */
	label: string,
	/** actual length; 0.0 for unsure */
	length: number,
	/** true if the user is unsure of the length */
	isUnsure: boolean,
});
